import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('notification-bell')
export class NotificationBell extends LitElement {
  @state() unread = 0;
  @state() notifications: any[] = [];
  @state() open = false;

  static styles = css`
    :host { display: inline-block; position: relative; }
    .bell-btn { position: relative; background: none; border: none; cursor: pointer; padding: 0.4rem; border-radius: 8px; transition: background 0.2s; }
    .bell-btn:hover { background: var(--tk-border); }
    .bell-icon { font-size: 1.2rem; }
    .badge { position: absolute; top: 0; right: 0; width: 16px; height: 16px; background: var(--tk-down); border-radius: 50%; font-size: 0.65rem; font-weight: 700; color: var(--tk-text); display: flex; align-items: center; justify-content: center; border: 2px solid var(--bg, var(--tk-bg)); }
    .panel { position: absolute; top: calc(100% + 8px); right: 0; width: 340px; background: var(--surface, var(--tk-panel)); border-radius: 12px; border: 1px solid var(--border, var(--tk-border)); box-shadow: 0 12px 40px rgba(0,0,0,0.4); z-index: 1000; overflow: hidden; }
    .panel-header { padding: 0.85rem 1rem; font-weight: 700; border-bottom: 1px solid var(--border, var(--tk-border)); display: flex; justify-content: space-between; align-items: center; }
    .mark-read { font-size: 0.78rem; color: var(--tk-accent); cursor: pointer; font-weight: 500; }
    .notif-list { max-height: 380px; overflow-y: auto; }
    .notif-item { padding: 0.85rem 1rem; border-bottom: 1px solid var(--border, var(--tk-border)); display: flex; gap: 0.75rem; cursor: pointer; transition: background 0.2s; }
    .notif-item:hover { background: var(--tk-accent-soft); }
    .notif-item.unread { background: var(--tk-accent-soft); }
    .notif-icon { width: 36px; height: 36px; border-radius: 50%; background: #7c3aed22; display: flex; align-items: center; justify-content: center; font-size: 1rem; flex-shrink: 0; }
    .notif-body { flex: 1; min-width: 0; }
    .notif-title { font-weight: 600; font-size: 0.88rem; }
    .notif-text { font-size: 0.8rem; color: var(--muted, var(--tk-dim)); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .notif-time { font-size: 0.72rem; color: var(--muted, var(--tk-dim)); margin-top: 2px; }
    .empty { padding: 2rem; text-align: center; color: var(--muted, var(--tk-dim)); font-size: 0.9rem; }
    .overlay { position: fixed; inset: 0; z-index: 999; }
  `;

  connectedCallback() {
    super.connectedCallback();
    this.loadNotifications();
    setInterval(() => this.loadNotifications(), 30000);
  }

  async loadNotifications() {
    try {
      const data = await fetch('/api/teknik/notifications').then(r => r.json());
      this.notifications = data.notifications || [];
      this.unread = data.unreadCount || 0;
    } catch {}
  }

  async markRead() {
    await fetch('/api/teknik/notifications/read', { method: 'POST' });
    this.unread = 0;
    this.notifications = this.notifications.map(n => ({ ...n, read: true }));
  }

  toggle() {
    this.open = !this.open;
    if (this.open && this.unread > 0) {
      setTimeout(() => this.markRead(), 1500);
    }
  }

  iconFor(type: string) {
    const bi = 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons';
    const map: Record<string, string> = {
      security: 'shield-lock', message: 'chat-dots', admin: 'exclamation-triangle',
      minecraft: 'controller', system: 'megaphone',
    };
    const name = map[type] || 'bell';
    return html`<img src="${bi}/${name}.svg" style="width:14px;height:14px;filter:brightness(0) saturate(100%) invert(1);opacity:0.7" alt="" />`;
  }

  render() {
    return html`
      ${this.open ? html`<div class="overlay" @click=${() => this.open = false}></div>` : ''}
      <button class="bell-btn" @click=${this.toggle}>
        <span class="bell-icon"><img src="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/bell.svg" style="width:18px;height:18px;filter:brightness(0) saturate(100%) invert(1);opacity:0.75;vertical-align:middle" alt="Notifications" /></span>
        ${this.unread > 0 ? html`<span class="badge">${this.unread > 9 ? '9+' : this.unread}</span>` : ''}
      </button>
      ${this.open ? html`
        <div class="panel">
          <div class="panel-header">
            Notifications
            ${this.unread > 0 ? html`<span class="mark-read" @click=${this.markRead}>Mark all read</span>` : ''}
          </div>
          <div class="notif-list">
            ${this.notifications.length === 0 ? html`<div class="empty">No notifications yet</div>` : this.notifications.map(n => html`
              <div class="notif-item ${n.read ? '' : 'unread'}" @click=${() => n.link ? window.location.href = n.link : undefined}>
                <div class="notif-icon">${this.iconFor(n.type)}</div>
                <div class="notif-body">
                  <div class="notif-title">${n.title}</div>
                  ${n.body ? html`<div class="notif-text">${n.body}</div>` : ''}
                  <div class="notif-time">${new Date(n.created_at).toLocaleString()}</div>
                </div>
              </div>
            `)}
          </div>
        </div>
      ` : ''}
    `;
  }
}
